<template>
  <div class="childRank">
    <el-form :inline="true" class="my-form-template" label-width="80px">
      <el-form-item label="所属部门">
        <el-cascader :options="deptList" v-model="deptId" :props="cascaderProps" filterable clearable></el-cascader>
      </el-form-item>
      <el-button class="cxbt org-btn" type="primary" @click="querySubRank">查询</el-button>
    </el-form>
    <div class="header">
      <div class="desc">统计本机构直属员工已过犹豫期（含续期）保单业绩</div>
    </div>
    <div class="contentTable">
      <el-table
        :data="tableData"
        v-loading="listLoading"
        border
        class="list-table"
        tooltip-effect="dark"
      >
        <emptyBox slot="empty"></emptyBox>
        <el-table-column type="index"></el-table-column>

        <el-table-column prop="name" label="员工姓名" min-width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="mobile" label="电话" min-width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="deptmantName" label="所属部门" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.deptmantName?scope.row.deptmantName:'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="入驻时间" min-width="160" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="customNum" label="客户数（人）" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="policyNum" label="出单数" min-width="100" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="totleFee" label="总保费（元）" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" min-width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="godetail(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
//当前实例组件

export default {
  data: () => ({
    listLoading:true,
    tableData: [],
    deptList:[],// 部门列表
    deptId:'', // 部门id
    cascaderProps: {
      checkStrictly: true, //是否严格的遵守父子节点不互相关联
      value: 'deptId', //指定选项的值为选项对象的某个属性值
      label: 'deptmantName', //指定选项标签为选项对象的某个属性值
      emitPath: false, //在选中节点改变时，是否返回由该节点所在的各级菜单的值所组成的数组，若设置 false，则只返回该节点的值
    },
  }),
  components: {},
  created() {
    this.querySubRank();
    this.getDeptList()
  },
  methods: {
    querySubRank: function() {
      this.listLoading = true;
      this.$http({
        url: "/master/subAccount/querySubRank",
        type: "put",
        params: {
          departmentId:this.deptId
        }
      }).then((data)=> {
        this.listLoading = false;
        this.tableData = data.data;
      });
    },
     // 获取部门列表
    getDeptList() {
      this.$http({
        url: '/master/mechanDept/deptSelectTree',
        type: 'PUT',
        params: {},
      }).then((res) => {
        this.deptList = this.handleDeptTree(res.data)
      })
    },
    // 处理为空的children，el-cascader为空的数组会展示暂无数据
    handleDeptTree(data){
     let val = data.map(item=>{
        if(item.children.length==0){
          item.children=''
        }else{
          this.handleDeptTree(item.children)
        }
        return item
      })
      return val
    },
    godetail: function(row) {
      this.$router.push({
        path: "/childAchiev",
        query: {
          id: row.mechanId,
          mobile: row.mobile,
          name: row.name
        }
      });
    }
  },
  mounted() {}
};
</script>
<style lang="scss">
.childRank {
  background: #fff;
  min-height: 800px;
  .header {
    i {
      display: inline-block;
      width: 5px;
      height: 16px;
      vertical-align: middle;
      background: #ff9700;
    }
    span {
      font-size: 16px;
      vertical-align: middle;
      margin-left: 10px;
    }
    .desc {
      color: red;
      font-size: 14px;
    }
  }
  .contentTable {
    margin-top: 10px;
  }
}
</style>
<style lang="scss" scoped>
.my-form-template{
  margin-bottom: 0;
  &::v-deep{
  .el-form-item{
    .el-form-item__content{
        .el-cascader{
          line-height: 32px;
        }
      }
    }
  }
}

</style>
